import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/path';
import { Box, Button, Typography } from '@mui/material';

export const DashboardPage = () => {
    const navigate = useNavigate();
    return (
        <Box
            width="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            px={2.5}
            py={2}
        >
            <Typography variant="h2" my={5} mx="auto">
                Welcome to the DashboardPage
            </Typography>
            <Button onClick={() => navigate(PATH.ROOT)} variant="outlined">
                Go to Home page
            </Button>
        </Box>
    );
};
